import { render, staticRenderFns } from "./invoices.vue?vue&type=template&id=3733d3b0"
import script from "./invoices.vue?vue&type=script&lang=js"
export * from "./invoices.vue?vue&type=script&lang=js"
import style0 from "./invoices.vue?vue&type=style&index=0&id=3733d3b0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3733d3b0')) {
      api.createRecord('3733d3b0', component.options)
    } else {
      api.reload('3733d3b0', component.options)
    }
    module.hot.accept("./invoices.vue?vue&type=template&id=3733d3b0", function () {
      api.rerender('3733d3b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/users/invoices.vue"
export default component.exports